/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 16/10/23
 */

import React from 'react';
import NavigateProvider from '@/components/contexts/NaviateContext/NavigateProvider';
import UserSupervision from '@/components/pages/Admin/UserSupervision';

const AdminUserSupervision = () => {
    return (
        <NavigateProvider prefix="/admin/supervision" admin>
            <UserSupervision />
        </NavigateProvider>
    );
};

export default AdminUserSupervision;
